<!-- eslint-disable vue/multi-word-component-names -->
<!-- Features and Events Page -->
<template>
  <page-layout header="Features and Interviews">
    <divider />
    <div class="cards">
      <card
        :image-source="cardImages.huffPost"
        header="Huffington Post"
        description="Right On Time: Tales Of A Not-So-Late Bloomer"
        card-link="https://www.huffpost.com/entry/late-bloomer_b_5627864"
      />
      <card
        :image-source="cardImages.modernLoss"
        header="Modern Loss"
        description="Wills and Grace"
        card-link="https://modernloss.com/wills-and-grace/"
      />
      <card
        :image-source="cardImages.theRumpus"
        header="The Rumpus"
        description="Super Hot Prof-on-Student Word Sex: Along Came Polly"
        card-link="https://therumpus.net/2014/06/11/super-hot-prof-on-student-word-sex-13-along-came-polly/"
      />
      <card
        :image-source="cardImages.kboo1"
        header="KBOO"
        description="Local Author Polly Dugan: 'So Much a Part of You'"
        card-link="https://kboo.fm/media/34868-local-author-polly-dugan-so-much-part-you"
      />
      <card
        :image-source="cardImages.kboo2"
        header="KBOO"
        description="Polly Dugan on her new novel 'The Sweetheart Deal'"
        card-link="https://kboo.fm/media/40525-polly-dugan-her-new-novel-sweetheart-deal"
      />
      <card
        :image-source="cardImages.lauraStanfill"
        header="Laura Stanfill"
        description="Author Interview: Polly Dugan on Her Debut Linked Short Story
        Collection, 'So Much a Part of You'"
        card-link="https://laurastanfill.wordpress.com/2014/06/11/author-interview-polly-dugan-on-her-debut-linked-short-story-collection-so-much-a-part-of-you/"
      />
    </div>
    <events-drawer header="Upcoming Events" :events="upcomingEvents" />
    <events-drawer header="Past Events" :events="pastEvents" />
  </page-layout>
</template>

<script>
// import components
import PageLayout from "./global-styles/layout/PageLayout.vue";
import Divider from "./global-styles/default/Divider.vue";
import Card from "./global-styles/components/Card.vue";
import huffPost from "@/assets/images/card-images/huff-post.jpg";
import modernLoss from "@/assets/images/card-images/modern-loss.jpg";
import theRumpus from "@/assets/images/card-images/the-rumpus.jpg";
import kboo1 from "@/assets/images/card-images/kboo-1.jpg";
import kboo2 from "@/assets/images/card-images/kboo-2.jpg";
import lauraStanfill from "@/assets/images/card-images/laura-stanfill.jpg";
import EventsDrawer from "./global-styles/layout/EventsDrawer.vue";

export default {
  name: "Event-Features",
  components: {
    PageLayout,
    Divider,
    Card,
    EventsDrawer,
  },
  data() {
    return {
      cardImages: {
        huffPost: huffPost,
        modernLoss: modernLoss,
        theRumpus: theRumpus,
        kboo1: kboo1,
        kboo2: kboo2,
        lauraStanfill: lauraStanfill,
      },
      pastEvents: [
        {
          title: "Elliott Bay Book Company",
          details: "Seattle, 12/5/25",
          link: "https://sibyllinepress.com/events/polly-dugan-brings-the-house-of-cavanaugh-to-seattle-wa/",
          content:
            "Polly Dugan joins conversation with Seattle-based author Jennie Shortridge at Elliott Bay Book Company on Friday December 5th at 7 pm for a talk and signing of her novel, The House of Cavanaugh.",
        },
        {
          title: "Broadway Books",
          details: "Portland, 11/6/25",
          link: "https://broadwaybooks.net/event/2025-11-06/celebrating-writers-sibylline-press-polly-dugan-suzanne-samuels-erin-van-rheenen",
          content:
            "Celebrating Writers of Sibylline Press with Polly Dugan, Suzanne Samuels, Erin Van Rheenen, and Temple Lentz",
        },
        {
          title: "Annie Bloom's Books",
          details: "Portland, 11/4/25",
          link: "https://annieblooms.com/event/2025-11-04/reading-polly-dugan-laura-stanfill",
          content:
            "Annie Bloom's Books welcomed Portland author Polly Dugan for a reading from her new novel, The House of Cavanaugh. Polly will be in conversation with local publisher and author Laura Stanfill.",
        },
        {
          title: "Hoffman Center for the Arts",
          details: "Manzanita, 10/17/25",
          link: "https://hoffmanarts.org/events/author-reading-with-polly-dugan/",
          content:
            "An evening with author Polly Dugan as she reads from her latest novel, The House of Cavanaugh. This event had taken place at the Hoffman Center for the Arts in Manzanita, Oregon on October 17th at 7 pm.",
        },
        {
          title: "Wordstock",
          details: "Portland, 11/7/15",
          link: "https://www.literary-arts.org/organizer/polly-dugan/",
          content:
            "Polly Dugan participated in the 2015 Wordstock Festival in Portland, Oregon, where she read from her novel 'So Much a Part of You' and engaged in a Q&A session with attendees.",
        },
        {
          title: "Cannon Beach Book Company",
          details: "Cannon Beach, 8/22/15",
          link: "http://cannonbeachbooks.com",
          content:
            "Polly Dugan participated in a reading and signing event at the Cannon Beach Book Company in Cannon Beach, Oregon, where she shared her novel 'So Much a Part of You' with attendees and discussed her inspiration for the book.",
        },
        {
          title: "University Book Store",
          details: "Seattle, 7/10/15",
          link: "https://www.ubookstore.com",
          content:
            "Polly Dugan had a book signing event at the University Book Store in Seattle, Washington, where she read from her novel 'So Much a Part of You' and interacted with readers.",
        },
        {
          title: "Annie Bloom's Books",
          details: "Portland, 7/6/15",
          link: "https://annieblooms.com/event/robin-mclean-and-polly-dugan",
          content:
            "Polly Dugan participated in a reading and discussion event at Annie Bloom's Books in Portland, Oregon, where she shared insights about her writing process and the themes of her novel 'So Much a Part of You'.",
        },
        {
          title: "Powell's Books",
          details: "Portland, 6/11/15",
          link: "https://www.powells.com/cgi-bin/calendar#6619",
          content:
            "Polly Dugan had a book signing event at Powell's Books in Portland, Oregon, where she read excerpts from her novel 'So Much a Part of You' and interacted with readers.",
        },
      ],
    };
  },
};
</script>

<style scoped>
.cards {
  justify-items: center;
  justify-content: center;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  max-width: 100%;
  gap: 1rem;
  padding-top: 2rem;
  align-items: stretch;
}
/* Tablets */
@media (max-width: 768px) {
  .cards {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 480px) {
  .cards {
    grid-template-columns: repeat(1, minmax(0, 1fr));
    width: 100%;
  }
}
</style>
